/* Ends & Picks — made-to-measure shirt builder */
(function () {
  'use strict';

  var MEASURES = [
    ['m_neck', 'Neck'], ['m_chest', 'Chest'], ['m_waist', 'Waist'], ['m_seat', 'Seat'],
    ['m_shoulder', 'Shoulder'], ['m_sleeve', 'Sleeve'], ['m_length', 'Length'],
    ['m_bicep', 'Bicep'], ['m_wrist', 'Wrist']
  ];
  var MONO_COLORS = { Grey: '#5c6670', White: '#ffffff', Black: '#22262a', Red: '#e11421' };
  var MONO_POS = { Cuff: [87, 89], Chest: [66, 34] };
  var GROUP_LABEL = { collar: 'Collar', sleeve: 'Sleeve', cuff: 'Cuff', placket: 'Placket', pocket: 'Pocket', back: 'Back' };
  var STORE_KEY = 'ep_measurements';

  function readStore() {
    try { return JSON.parse(window.localStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; }
  }
  function writeStore(obj) {
    try { window.localStorage.setItem(STORE_KEY, JSON.stringify(obj)); } catch (e) { /* storage unavailable */ }
  }

  function money(cents, format) {
    var n = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(Math.round(cents / 100));
    if (!format || format.indexOf('{{') === -1) return '₹' + n;
    return format.replace(/\{\{\s*[a-z_]+\s*\}\}/, n);
  }

  function init(root) {
    var id = root.getAttribute('data-section');
    var jsonEl = document.querySelector('[data-ep-json="' + id + '"]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var product = data.product || {};
    var choices = data.choices || {};
    var groups = (data.groups || []).filter(function (g) { return (choices[g] || []).length; });
    var form = root.querySelector('[data-ep-form]');
    var preview = root.querySelector('[data-ep-preview]');
    var frame = root.querySelector('.ep-stage__frame');
    var monoEl = root.querySelector('[data-ep-mono]');
    var errorEl = root.querySelector('[data-ep-error]');
    var submitBtn = root.querySelector('[data-ep-submit]');
    var pre = !!data.prelaunch;
    var view = 'front';

    function field(name) { return form.elements[name]; }
    function val(name) {
      var checked = form.querySelector('[name="' + name + '"]:checked');
      if (checked) return checked.value;
      var el = field(name);
      return el && el.value !== undefined ? el.value : '';
    }
    function isOn(name) { var el = field(name); return !!(el && el.checked); }
    function choice(g) {
      var v = val(g);
      return (choices[g] || []).filter(function (c) { return c.name === v; })[0] || null;
    }
    function shortSleeve() { return /short/i.test(val('sleeve')); }
    function active(g) { return g === 'cuff' ? !shortSleeve() : true; }
    function clean(s) { return String(s || '').replace(/,/g, ' ').trim(); }

    // Presets: product metafield first, then URL parameters.
    var params = new URLSearchParams(window.location.search);
    var preset = {};
    if (data.preset && typeof data.preset === 'object') for (var pk in data.preset) preset[pk] = data.preset[pk];
    groups.concat(['mono_place']).forEach(function (k) { if (params.get(k)) preset[k] = params.get(k); });
    Object.keys(preset).forEach(function (k) {
      var want = String(preset[k]).toLowerCase();
      var inputs = Array.prototype.slice.call(form.querySelectorAll('input[name="' + k + '"]'));
      var hit = inputs.filter(function (inp) { return inp.value.toLowerCase() === want; })[0]
        || inputs.filter(function (inp) { return inp.value.toLowerCase().indexOf(want) === 0; })[0];
      if (hit) hit.checked = true;
    });

    // Remembered measurements.
    var saved = readStore();
    if (saved) {
      Object.keys(saved).forEach(function (k) {
        var el = field(k);
        if (!el) return;
        if (el.length && el[0] && el[0].type === 'radio') {
          Array.prototype.forEach.call(el, function (r) { r.checked = r.value === saved[k]; });
        } else if (el.type !== 'checkbox') {
          el.value = saved[k];
        }
      });
    }

    function setLayer(name, url, show) {
      var img = preview.querySelector('[data-layer="' + name + '"]');
      if (!img) return;
      if (url && img.getAttribute('src') !== url) img.setAttribute('src', url);
      if (show === false || !url) img.setAttribute('hidden', ''); else img.removeAttribute('hidden');
    }

    function baseImage() {
      var c = choice('sleeve');
      if (c && c.img) return c.img;
      var first = (choices.sleeve || []).filter(function (x) { return x.img; })[0];
      return first ? first.img : null;
    }

    function renderPreview() {
      var back = view === 'back' && data.backImage;
      var s = choice('sleeve');
      setLayer('body', back ? ((s && s.backImg) || data.backImage) : baseImage(), true);
      var b = choice('back');
      setLayer('back', b && b.img, !!back);
      ['collar', 'cuff', 'placket', 'pocket'].forEach(function (g) {
        var c = choice(g);
        // The back view shows a choice only when it has its own back-view image (cuffs).
        var url = c && (back ? c.backImg : c.img);
        setLayer(g, url, active(g) && !!url);
      });
    }

    function selections() {
      var out = [];
      groups.forEach(function (g) { if (active(g)) out.push([g, val(g)]); });
      return out;
    }

    function update() {
      // Short sleeves have no cuffs.
      var cuffSet = root.querySelector('[data-ep-group="cuff"]');
      if (cuffSet) cuffSet.hidden = !active('cuff');
      var cuffMono = root.querySelector('[data-ep-mono-cuff]');
      if (cuffMono) {
        cuffMono.hidden = shortSleeve();
        if (shortSleeve() && val('mono_place') === 'Cuff') {
          var chest = form.querySelector('input[name="mono_place"][value="Chest"]');
          if (chest) chest.checked = true;
        }
      }

      renderPreview();

      groups.forEach(function (g) {
        var cur = root.querySelector('[data-ep-current="' + g + '"]');
        if (cur) cur.textContent = '· ' + val(g);
        var note = root.querySelector('[data-ep-note="' + g + '"]');
        var c = choice(g);
        if (note) { note.textContent = (c && c.note) || ''; note.hidden = !(c && c.note); }
      });

      var monoOn = isOn('monogram');
      root.querySelector('[data-ep-monogram]').hidden = !monoOn;
      var text = (val('mono_text') || '').toUpperCase().replace(/[^A-Z.&]/g, '').slice(0, 3);
      if (monoOn && text && view === 'front') {
        var pos = MONO_POS[val('mono_place')] || MONO_POS.Chest;
        monoEl.textContent = text;
        monoEl.style.left = pos[0] + '%';
        monoEl.style.top = pos[1] + '%';
        monoEl.style.color = MONO_COLORS[val('mono_color')] || MONO_COLORS.Grey;
        monoEl.style.fontSize = Math.max(11, preview.clientWidth * 0.032) + 'px';
        monoEl.style.textShadow = val('mono_color') === 'White' ? '0 0 1px #9da6af' : 'none';
        monoEl.hidden = false;
      } else {
        monoEl.hidden = true;
      }

      var mode = val('measure_mode');
      var measure = root.querySelector('[data-ep-measure]');
      var call = root.querySelector('[data-ep-call]');
      if (measure && call) {
        measure.hidden = mode !== 'enter';
        call.hidden = mode !== 'call';
        Array.prototype.forEach.call(measure.querySelectorAll('input,textarea'), function (el) { el.disabled = mode !== 'enter'; });
        Array.prototype.forEach.call(call.querySelectorAll('input,select'), function (el) { el.disabled = mode !== 'call'; });
        Array.prototype.forEach.call(root.querySelectorAll('input[name="unit"]'), function (el) { el.disabled = mode !== 'enter'; });
      }

      var chips = selections().map(function (s) {
        var v = s[1];
        if (s[0] === 'pocket') return /none/i.test(v) ? 'No pocket' : v + ' pocket';
        if (s[0] === 'sleeve') return v + ' sleeves';
        if (s[0] === 'back') return v;
        if (s[0] === 'cuff' && v.indexOf(' · ') !== -1) return v.replace(' · ', ' cuff · ');
        return v + ' ' + GROUP_LABEL[s[0]].toLowerCase();
      });
      if (monoOn && text) chips.push('Monogram ' + text + ' · ' + val('mono_place'));
      var summary = root.querySelector('[data-ep-summary]');
      summary.innerHTML = '';
      chips.forEach(function (c, i) {
        var s = document.createElement('span');
        s.className = 'ep-chip';
        s.textContent = c;
        summary.appendChild(s);
      });

      if (pre) { setWaitlistTags(); return; }
      var label = money(product.price || 0, data.moneyFormat);
      ['[data-ep-price]', '[data-ep-price-btn]', '[data-ep-price-sticky]'].forEach(function (sel) {
        var el = root.querySelector(sel);
        if (el) el.textContent = label;
      });
      if (submitBtn) submitBtn.disabled = !(product.variant && product.available);
    }

    function setWaitlistTags() {
      var tagsEl = document.querySelector('[data-ep-wl-tags]');
      if (!tagsEl) return;
      var tags = ['waitlist', 'prelaunch', 'designer', 'look:' + (product.handle || '')];
      selections().forEach(function (s) { tags.push(s[0] + ':' + clean(s[1])); });
      if (isOn('monogram')) tags.push('monogram:' + val('mono_place').toLowerCase());
      tagsEl.value = tags.join(',');
    }

    function measurementSummary() {
      var unit = val('unit') || 'in';
      var parts = [];
      MEASURES.forEach(function (m) {
        var v = (field(m[0]) || {}).value;
        if (v) parts.push(m[1] + ' ' + v);
      });
      var line = parts.join(' · ');
      if (line) line += ' (' + unit + ')';
      var h = (field('m_height') || {}).value, w = (field('m_weight') || {}).value;
      if (h) line += ' · Height ' + h + ' cm';
      if (w) line += ' · Weight ' + w + ' kg';
      return line;
    }

    function validate() {
      errorEl.textContent = '';
      var scope = root.querySelector(val('measure_mode') === 'call' ? '[data-ep-call]' : '[data-ep-measure]');
      var missing = Array.prototype.filter.call(scope.querySelectorAll('[required]'), function (el) {
        return !el.disabled && !String(el.value).trim();
      });
      if (missing.length) {
        errorEl.textContent = val('measure_mode') === 'call'
          ? 'Add a phone number so we can call you for your measurements.'
          : 'Please fill in all starred measurements, or choose “Book a measurement call”.';
        missing[0].focus();
        return false;
      }
      if (isOn('monogram') && !String(val('mono_text')).trim()) {
        errorEl.textContent = 'Add the initials for your monogram, or switch the monogram off.';
        field('mono_text').focus();
        return false;
      }
      return true;
    }

    function submit(e) {
      if (e) e.preventDefault();
      if (pre || !product.variant) return;
      if (!validate()) return;

      var build = 'EP' + Date.now().toString(36).toUpperCase();
      var props = {};
      selections().forEach(function (s) { props[GROUP_LABEL[s[0]]] = s[1]; });
      if (data.preset) props['Started from'] = product.title;
      if (isOn('monogram')) props['Monogram'] = String(val('mono_text')).toUpperCase().slice(0, 3) + ' · ' + val('mono_color') + ' thread · ' + val('mono_place');
      if (val('measure_mode') === 'call') {
        props['Measurements'] = 'Measurement call requested';
        props['Phone'] = val('call_phone');
        props['Best time to call'] = val('call_time');
      } else {
        props['Measurements'] = measurementSummary();
        if (val('m_profile')) props['Profile'] = val('m_profile');
        if (val('m_notes')) props['Fit notes'] = val('m_notes');
        if (isOn('m_save')) {
          var store = { unit: val('unit') };
          MEASURES.concat([['m_height'], ['m_weight'], ['m_profile'], ['m_notes']]).forEach(function (m) {
            var el = field(m[0]); if (el && el.value) store[m[0]] = el.value;
          });
          writeStore(store);
        }
      }
      props['_build'] = build;

      var items = [{ id: product.variant, quantity: 1, properties: props }];

      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root_url + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (body) { return { ok: r.ok, body: body }; });
      }).then(function (res) {
        if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || 'Could not add to cart');
        window.location.href = root_url + 'cart';
      }).catch(function (err) {
        errorEl.textContent = err.message || 'Something went wrong. Please try again.';
        submitBtn.disabled = false;
        submitBtn.removeAttribute('aria-busy');
      });
    }

    // Look view (photos + Customize) and build view (your shirt).
    var hasLook = !!root.querySelector('[data-ep-tab="look"]');
    function setMode(m) {
      var look = hasLook && m === 'look';
      root.classList.toggle('is-look-mode', look);
      frame.classList.toggle('is-look', look);
      Array.prototype.forEach.call(root.querySelectorAll('[data-ep-tab]'), function (t) {
        t.setAttribute('aria-selected', String(t.getAttribute('data-ep-tab') === (look ? 'look' : 'build')));
      });
      if (!look) update();
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-ep-tab]'), function (tab) {
      tab.addEventListener('click', function () { setMode(tab.getAttribute('data-ep-tab')); });
    });
    var customize = root.querySelector('[data-ep-customize]');
    if (customize) customize.addEventListener('click', function () {
      setMode('build');
      var top = root.querySelector('.ep-builder__grid').getBoundingClientRect().top + window.pageYOffset - 96;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
    var lookMain = root.querySelector('.ep-stage__look');
    Array.prototype.forEach.call(root.querySelectorAll('.ep-tray__item'), function (b) {
      b.addEventListener('click', function () {
        if (lookMain) {
          lookMain.removeAttribute('srcset');
          lookMain.setAttribute('src', b.getAttribute('data-src'));
          lookMain.setAttribute('alt', b.getAttribute('data-alt') || '');
        }
        Array.prototype.forEach.call(root.querySelectorAll('.ep-tray__item'), function (x) {
          x.classList.toggle('is-active', x === b);
          x.setAttribute('aria-pressed', String(x === b));
        });
      });
    });
    if (hasLook && params.get('customize')) setMode('build');

    // Front / back view.
    function setView(v) {
      view = v;
      Array.prototype.forEach.call(root.querySelectorAll('[data-ep-view]'), function (b) {
        var on = b.getAttribute('data-ep-view') === v;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', String(on));
      });
      update();
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-ep-view]'), function (b) {
      b.addEventListener('click', function () { setView(b.getAttribute('data-ep-view')); });
    });

    form.addEventListener('change', function (e) {
      var name = e.target && e.target.name;
      if (name && root.classList.contains('is-look-mode')) setMode('build');
      if (data.backImage) {
        if (name === 'back' && view !== 'back') { setView('back'); return; }
        if (name && name !== 'back' && groups.indexOf(name) !== -1 && view !== 'front') { setView('front'); return; }
      }
      update();
    });
    form.addEventListener('input', function (e) { if (e.target.name === 'mono_text') update(); });
    form.addEventListener('submit', submit);
    var sticky = root.querySelector('[data-ep-sticky-btn]');
    if (sticky) sticky.addEventListener('click', function () { submit(); });
    window.addEventListener('resize', update);
    update();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-ep-builder]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
